import './App.css';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Join from "./component/Join/Join";
import Chat from "./component/Chat/Chat";


function App() { 

  return (
    <div className="App">
      
      <Router basename='/live_realtime_chatapp_f'>
        <Routes>
        <Route exact path="/" element={<Join/>}/>
        <Route path="/chat" element={<Chat/>}/>
        </Routes>
      </Router>

    </div>
  );
}

export default App;
